import { render, staticRenderFns } from "./AutoSaveConfiguration.vue?vue&type=template&id=ed7cc392&scoped=true&"
import script from "./AutoSaveConfiguration.vue?vue&type=script&lang=ts&"
export * from "./AutoSaveConfiguration.vue?vue&type=script&lang=ts&"
import style0 from "./AutoSaveConfiguration.vue?vue&type=style&index=0&id=ed7cc392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7cc392",
  null
  
)

export default component.exports